import moment from "moment-timezone";

export const toLocalTimezone = (timestamp: string): moment.Moment =>
  moment(timestamp).local();

export const toLocalTime = (timestamp: string): string =>
  toLocalTimezone(timestamp).format(`h:mm a`)
